import { Question, Option } from '../types/types';

export interface StepData {
  option?: Option | Option[];
  [key: string]: unknown;
}

export interface GetStepMetadataFunction {
  (stepId: string): StepData;
}

/**
 * Determines which questions should be shown based on conditional logic.
 * Handles branching where follow-up questions are only shown if the selected
 * option in a previous question has a nextQuestionId.
 */
export function getConditionalQuestions(
  stepQuestions: Question[],
  getStepMetadataById: GetStepMetadataFunction,
): Question[] {
  const optionWithFollowUpQuestion = stepQuestions
    .flatMap((question) => question?.options)
    .find((option) => option?.nextQuestionId != null);

  const followUpQuestionId = optionWithFollowUpQuestion?.nextQuestionId;

  if (followUpQuestionId) {
    const firstQuestion = stepQuestions.find((question) =>
      question?.options?.some(
        (option) => option?.nextQuestionId === followUpQuestionId,
      ),
    );

    if (firstQuestion) {
      const firstQuestionData = getStepMetadataById(firstQuestion.id);
      const hasFirstQuestionAnswer =
        firstQuestionData?.option &&
        (Array.isArray(firstQuestionData.option)
          ? firstQuestionData.option.length > 0
          : true);

      if (!hasFirstQuestionAnswer) {
        return stepQuestions.filter((q) => q.id !== followUpQuestionId);
      }

      const allCurrentOptions = firstQuestionData.option
        ? Array.isArray(firstQuestionData.option)
          ? firstQuestionData.option
          : [firstQuestionData.option]
        : [];

      const selectedOptionWithFollowUp = allCurrentOptions.find(
        (option) => option?.nextQuestionId === followUpQuestionId,
      );

      if (!selectedOptionWithFollowUp) {
        return stepQuestions.filter((q) => q.id !== followUpQuestionId);
      }
    }
  }

  return stepQuestions;
}
